import {UserReportConfig} from './user-report-config.model';
import {DeliveryFrequency} from '../../../../shared/domain/delivery-frequency.enum';

export class ScheduledUserReport {
  report: UserReportConfig;
  recipients: string[];
  id: string;
  name: string;
  createdOn: number;
  lastUpdatedOn: number;
  deliveryFrequency: DeliveryFrequency;
}
